export interface WireReturnReasonOption {
  label: string;
  value: string;
  // ISO 20022 return reason code sent on the pacs.004, mirroring the backend mapping for each reason.
  code: string;
}

// `other` is rejected by the API for wire reversals, so it is not offered.
export const wireReturnReasons: WireReturnReasonOption[] = [
  { label: 'Invalid beneficiary account number', value: 'invalid_beneficiary_account_number', code: 'AC01' },
  { label: 'Beneficiary mismatch', value: 'beneficiary_mismatch', code: 'BE01' },
  { label: 'Requested by beneficiary', value: 'beneficiary_request', code: 'BE05' },
  { label: 'Requested by originator', value: 'originator_request', code: 'FOCR' },
  { label: 'Account closed', value: 'account_closed', code: 'AC04' },
  { label: 'Account blocked', value: 'account_blocked', code: 'AC06' },
  { label: 'Incorrect amount', value: 'incorrect_amount', code: 'AM06' },
  { label: 'Fraud', value: 'fraud', code: 'FR01' },
  { label: 'Missing originator data', value: 'missing_originator_data', code: 'RR01' },
  { label: 'Missing beneficiary data', value: 'missing_beneficiary_data', code: 'RR03' },
  { label: 'Compliance', value: 'compliance', code: 'RR04' },
];

export const swiftReturnReasons: WireReturnReasonOption[] = [
  { label: 'Incorrect beneficiary account', value: 'incorrect_beneficiary_account', code: 'AC01' },
  { label: 'Beneficiary account blocked', value: 'beneficiary_account_blocked', code: 'AC06' },
  { label: 'Incorrect amount', value: 'incorrect_amount', code: 'AM09' },
  { label: 'Beneficiary mismatch', value: 'beneficiary_mismatch', code: 'BE01' },
  { label: 'Refused by beneficiary', value: 'refused_by_beneficiary', code: 'BE05' },
  { label: 'Cancellation requested', value: 'cancellation_requested', code: 'FOCR' },
  { label: 'Fraud', value: 'fraud', code: 'FR01' },
  { label: 'Compliance rejected', value: 'compliance_rejected', code: 'NOCM' },
  { label: 'Missing originator data', value: 'missing_originator_data', code: 'RR02' },
];

// Shown like ACH and check returns: the network code in the chip, the readable reason beneath it.
// Reasons outside the list (e.g. a raw code from a network-initiated return) show as-is with no description.
export const getReturnReasonDisplay = (reasons: WireReturnReasonOption[], value: string) => {
  const reason = reasons.find((option) => option.value === value);
  return { code: reason?.code ?? value, description: reason?.label };
};
